import type { AdminProfile, SlideInput } from '../../types'

const viteEnv = (import.meta as ImportMeta & { env?: { VITE_API_URL?: string } }).env
export const API_BASE = viteEnv?.VITE_API_URL || '/api'
export const STORAGE_TOKEN_KEY = 'admin_token'

export const EMPTY_SLIDE: SlideInput = {
  title: '',
  description: '',
  ctaLabel: 'Learn more',
  ctaHref: '#',
  image: '',
}

export const DEFAULT_PROFILE: AdminProfile = {
  displayName: 'Admin',
  firstName: '',
  lastName: '',
  taxCode: '',
  email: 'admin@example.com',
  avatarUrl: '',
  role: 'Super admin',
  bio: '',
  phone: '',
  residentialAddress: '',
  billingAddress: '',
  shippingAddress: '',
  timezone: 'Europe/Rome',
  language: 'it-IT',
  website: '',
  notifications: {
    product: true,
    marketing: false,
    security: true,
  },
}
